import { Injectable, OnDestroy, inject } from "@angular/core";
import { chain } from "lodash";
import { Observable, Subject } from "rxjs";
import { TradslagDTO } from "../models/mbf-models";
import { SkogsvardService } from "./skogsvard.service";

@Injectable()
export class AllSkogsvardTradslagService implements OnDestroy {
    private readonly skogsvardService = inject(SkogsvardService);

    private readonly tradslagForAtgarderSrc = new Subject<string>();
    private readonly cachedTradslagForAtgarder = new Map<string, number[]>();

    get tradslagChanged$(): Observable<string> {
        return this.tradslagForAtgarderSrc.asObservable();
    }

    private tradslagTypes: TradslagDTO[];

    constructor() {
        this.skogsvardService.getTradslag()
            .subscribe(tradslagTypesList => {
                this.tradslagTypes = tradslagTypesList;
            });
    }

    ngOnDestroy(): void {
        this.tradslagForAtgarderSrc.complete();
        this.cachedTradslagForAtgarder.clear();
    }

    getTradslagForAtgard(atgardGuid: string): string[] {
        const cached = this.getCachedForAtgard(atgardGuid);
        if (cached) {
            return chain(cached)
                .filter(tradslagid => !!tradslagid)
                .map(tradslagid => this.tradslagTypes.find(type => type.id === tradslagid).namn)
                .uniq()
                .value();
        }
        return [""];
    }

    getCachedForAtgard(atgardGuid: string): number[] {
        if (this.cachedTradslagForAtgarder.has(atgardGuid)) {
            return this.cachedTradslagForAtgarder.get(atgardGuid);
        } else {
            return null;
        }
    }

    updateCacheForAtgard(atgardGuid: string, tradslagsList: number[]) {
        this.cachedTradslagForAtgarder.set(atgardGuid, tradslagsList);
        this.tradslagForAtgarderSrc.next(atgardGuid);
    }

}
